export const phoneMaxLength = 10;

export const resetPinConstants = {
  heading: `# Reset your PIN`,
  subHeading: `### Please enter a new 4 digit PIN.`,
  setPinValidationSubText: `We will send you a OTP code to your mobile number to ensure you are the owner of this card.`,
  phoneNumberSubText: `${process.env.REACT_APP_PHONE_SUB_TEXT}`,
  defaultValue: {
    eaid: '',
    phone: '',
    pinCode: ''
  },
  validations: {
    eaid: {
      id: 'eaid',
      required: 'Unique Card Id is required',
      format: `Unique Card Id is invalid`,
    },
    phone: {
      id: 'phoneNumber',
      required: 'Mobile number is required',
      format: 'Mobile number must start with +61',
      minLength: `Mobile number must be ${phoneMaxLength} digits`,
      maxLength: `Mobile number must be ${phoneMaxLength} digits`,
    },
    pinCode: {
      id: 'pinCode',
      required: 'Pin is required',
      format: `Pin is invalid, must be 4 digits`,
    },
  },
};
